import { forwardRef, type Ref, type SVGProps } from "react";

function SvgVisaColored(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
      <path
        fill="#2566AF"
        d="M10.657 15.944H9.008l1.03-6.33h1.649zm-3.035-6.33L6.05 13.966l-.186-.937-.555-2.847s-.067-.57-.782-.57H1.931l-.03.107s.794.166 1.723.724l1.432 5.5h1.717l2.623-6.33zm12.963 6.33H22.1l-1.32-6.331h-1.325c-.612 0-.76.472-.76.472l-2.459 5.858h1.718l.344-.94h2.095zm-1.813-2.24.866-2.369.487 2.37zm-2.408-2.569.235-1.359s-.725-.276-1.482-.276c-.818 0-2.76.357-2.76 2.096 0 1.635 2.28 1.655 2.28 2.514 0 .86-2.045.706-2.72.164l-.245 1.421s.736.358 1.86.358 2.822-.583 2.822-2.168c0-1.646-2.3-1.799-2.3-2.514 0-.716 1.605-.624 2.31-.236"
      />
      <path
        fill="#E6A540"
        d="m5.865 13.03-.555-2.847s-.067-.57-.782-.57H1.931l-.03.107s1.248.26 2.445 1.229c1.145.926 1.519 2.081 1.519 2.081"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgVisaColored);
export default ForwardRef;
